module.exports = __webpack_public_path__ + "static/img/brand-1.3719e6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/promotion/brand-1.png
// module id = VyVN
// module chunks = 2